import {
  Wrench, Zap, Grid3x3, Paintbrush, PaintRoller, Hammer, DoorClosed, Bath, Home,
  Ruler, Droplet, Flame, Lightbulb, Fence, TreePine, Wind, Layers, Building2,
  KeyRound, MoreHorizontal, HardHat,
} from "lucide-react";

// Icon registry keyed by short icon key (stored in DB per category)
export const ICON_MAP = {
  wrench: Wrench,
  zap: Zap,
  grid: Grid3x3,
  paint: Paintbrush,
  roller: PaintRoller,
  hammer: Hammer,
  door: DoorClosed,
  bath: Bath,
  home: Home,
  ruler: Ruler,
  droplet: Droplet,
  flame: Flame,
  bulb: Lightbulb,
  fence: Fence,
  tree: TreePine,
  wind: Wind,
  layers: Layers,
  building: Building2,
  key: KeyRound,
  more: MoreHorizontal,
};

// Options shown in the icon picker (Settings > Ajouter une catégorie)
export const ICON_OPTIONS = [
  { key: "wrench", label: "Plomberie" },
  { key: "zap", label: "Électricité" },
  { key: "grid", label: "Carrelage" },
  { key: "paint", label: "Peinture" },
  { key: "roller", label: "Peinture (rouleau)" },
  { key: "hammer", label: "Maçonnerie" },
  { key: "door", label: "Menuiserie" },
  { key: "bath", label: "Salle de bain" },
  { key: "home", label: "Rénovation" },
  { key: "layers", label: "Toiture" },
  { key: "flame", label: "Chauffage" },
  { key: "wind", label: "Climatisation / VMC" },
  { key: "bulb", label: "Éclairage" },
  { key: "droplet", label: "Étanchéité" },
  { key: "fence", label: "Clôture" },
  { key: "tree", label: "Jardin / Espaces verts" },
  { key: "ruler", label: "Plâtrerie" },
  { key: "building", label: "Gros œuvre" },
  { key: "key", label: "Serrurerie" },
  { key: "more", label: "Autre" },
];

export const getCategoryIcon = (iconKey) => ICON_MAP[iconKey] || HardHat;

// Name-based map for back-office lists (default categories)
export const CATEGORY_ICONS = {
  "Plomberie": Wrench,
  "Électricité": Zap,
  "Carrelage": Grid3x3,
  "Peinture": Paintbrush,
  "Maçonnerie": Hammer,
  "Menuiserie": DoorClosed,
  "Rénovation salle de bain": Bath,
  "Rénovation intérieure": Home,
  "Autre": MoreHorizontal,
};

export const STATUS_STYLES = {
  "Nouvelle": "bg-sky-100 text-sky-800 border-sky-300",
  "Artisan assigné": "bg-indigo-100 text-indigo-800 border-indigo-300",
  "Devis envoyé": "bg-amber-100 text-amber-800 border-amber-300",
  "Chantier accepté": "bg-blue-100 text-blue-800 border-blue-300",
  "Terminé": "bg-emerald-100 text-emerald-800 border-emerald-300",
  "Annulé": "bg-rose-100 text-rose-800 border-rose-300",
};
